import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'

import Button from '../../common/components/Button'
import Layout from '../../common/components/Layout'
import WarningIcon from '../../assets/icons/warning.png'
import styles from './Warning.module.css'

const Warning = () => {
  const navigate = useNavigate()

  const handleContinueClick = () => {
    navigate('/feed')
  }

  return (
    <Layout
      contentStyles={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <div className={styles.icon}>
        <img src={WarningIcon} alt="Warning" />
      </div>
      <div
        className={styles.textContainer}
        dangerouslySetInnerHTML={{
          __html: t('warning.message')
            .split('\n')
            .map((paragraph) => `<p>${paragraph}</p>`)
            .join(''),
        }}
      />
      <div className={styles.actionContainer}>
        <Button title={t('warning.continue')} onClick={handleContinueClick} />
      </div>
    </Layout>
  )
}

export default Warning
